/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from '@api-util/mbp';
import restClient from '../../app/helpers/restClient';

const RESOURCE_PAGE_FACADE = '/v2/addresses';
const RESOURCE_ROOT_FACADE = '/checkout';
const RESOURCE_PAGE_ACTION = '/verify';
const CLIENT_ID = mbpUtil.getEnv('APP_ADDRESS_VERIFY_CLIENT_ID') || '';

const verifyAddress = (wcEnv = {}, jwtToken, payload = {}) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;

    const headers = {
        'content-type': 'application/json',
        'x-client-id': CLIENT_ID,
    };
    const resourcePage = `${RESOURCE_PAGE_FACADE}${RESOURCE_PAGE_ACTION}`;

    return restClient.postFacade(
        env,
        resourcePage,
        jwtToken,
        payload,
        null,
        headers,
        false,
    ).then((response) => response);
};

export default verifyAddress;
